export default __webpack_public_path__ + "static/media/cold-americano.29e994b4.png";